export default __webpack_public_path__ + "static/media/mailchimp copy 2.5748fa89.png";